export default "__VITE_ASSET__BMgskReW__"